<template>
  <BaseModalEditCreate
    :mode="mode"
    :title="$t('representative.properties')"
    :is-modified="false"
    @dismiss-changes="onDismissChanges"
    @save="onSave">
    <template #form>
      <div>
        <label for="order" class="text-sm font-medium">{{ $t('document-type.order') }}</label>
        <BaseInput
          ref="editFieldRef"
          v-model="modifiedField.properties!.order"
          color="base"
          :readonly="mode == 'view'"
          type="number" />
      </div>
      <div>
        <label for="width" class="text-sm font-medium">{{ $t('document-type.width') }}</label>
        <BaseInput
          v-model="modifiedField.properties!.width"
          color="base"
          type="number"
          :readonly="mode == 'view'" />
      </div>
      <div>
        <label for="caption" class="text-sm font-medium">{{ $t('document-type.caption') }}</label>
        <BaseInput
          v-model="modifiedField.properties!.caption"
          color="base"
          :readonly="mode == 'view'" />
      </div>
    </template>
  </BaseModalEditCreate>
</template>

<script setup lang="ts">
import BaseModalEditCreate from '../common/BaseModalEditCreate.vue';
import BaseInput from '../common/BaseInput.vue';
import { nextTick, onMounted, ref } from 'vue';
import { deepCopy } from '@/utils/data';
import type { ColumnField } from '@/types/DocumentTypes';

const props = defineProps<{
  field?: ColumnField;
  mode: 'view' | 'edit';
}>();

const emit = defineEmits(['close', 'save']);

const editFieldRef = ref<HTMLInputElement | null>(null);
const modifiedField = ref<ColumnField>({
  documentTypeCode: '',
  documentTypeId: '',
  fieldName: '',
  uniqueKey: '',
  properties: {
    order: undefined,
    width: undefined,
    caption: '',
  },
});

onMounted(() => {
  if (props.field) {
    modifiedField.value = deepCopy(props.field);
    // Initialize properties if it doesn't exist
    if (!modifiedField.value.properties) {
      modifiedField.value.properties = {
        order: undefined,
        width: undefined,
        caption: '',
      };
    }
  }
  nextTick(() => {
    editFieldRef.value?.focus();
  });
});

function onDismissChanges() {
  emit('close');
}

function onSave() {
  if (props.mode == 'view') emit('close');
  emit('save', modifiedField.value);
}
</script>
